// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SELECT_TOPIC = "Vyber si kateg\u00f3riu";
export const SEO_TITLE_FORUM_THREAD_NEW_CATEGORY = "Vyber si kateg\u00f3riu";
